import { formatCurrency } from "@/lib/conversion-utils";
import {
  REFERRAL_DISPLAY_CAP_AMOUNT,
  REFERRAL_DISPLAY_COMMISSION_BPS,
} from "@/lib/opportunity-utils";

const COMMISSION_PCT = REFERRAL_DISPLAY_COMMISSION_BPS / 100;
const PER_PERSON_CAP = formatCurrency(REFERRAL_DISPLAY_CAP_AMOUNT);

export const recruitersFaqs = [
  {
    question: "Who is this for?",
    answer:
      "Recruiters, sourcers, headhunters, and staffing firms who already know how to find people and want a faster way to get paid for it. You don't have to be the expert yourself. You bring the network and the judgment to know who fits a search; Terac handles the screening, verification, and payout.",
  },
  {
    question:
      "Do you work with staffing firms and recruiting partners, or just individuals?",
    answer:
      "Both, and staffing partners are a core part of how Terac fills demand. Whether you're a solo sourcer or a firm running a full desk, you work the same way: find the right person for an open search and submit them. There's no separate partner contract to sign, no minimums, and no in-house delivery team you're competing against.",
  },
  {
    question: "Do I have to screen or qualify candidates myself?",
    answer:
      "No. You source; Terac qualifies. Our AI Moderator runs a short voice screening that verifies and qualifies every candidate you submit, so you skip the interviews, resume formatting, and reference checks. Your job is the judgment on who to put forward.",
  },
  {
    question: "Which searches are hardest to fill right now?",
    answer:
      "Almost everything in the live feed is open because we haven't filled it yet. The demand board updates daily across AI research, engineering, and dozens of other categories. If your network reaches a niche we're struggling with, that's exactly where the placements are.",
  },
  {
    question: "How much do I earn per placement?",
    answer: `You earn ${COMMISSION_PCT}% of every payout your candidate is approved for on Terac, not just the first study. Earnings stack across every study they clear, up to a ${PER_PERSON_CAP} cap per person you place, stamped when they sign up.`,
  },
  {
    question: "When do I get paid?",
    answer:
      "Instantly. The moment your candidate is approved on a study, the commission deposits to your Terac account. No invoicing, no payout requests, no net-30, no waiting period. Withdraw to your preferred method whenever you like.",
  },
  {
    question: "Can I source for searches outside my own industry or country?",
    answer:
      "Yes. This is one of the biggest differences from other platforms. You see every open search in the feed (not just ones that match your background) so you can place the people in your network wherever they fit. A US-based recruiter can place a clinician in Brazil. A fintech recruiter can place a healthcare operator.",
  },
  {
    question: "Is there a contract, exclusivity, or seat fee?",
    answer:
      "None of those. No exclusivity, no seat fees, no contracts to negotiate. You can source on Terac alongside any other platform or your own agency clients. Sign up, submit, get paid.",
  },
  {
    question: "What counts as a 'placement' on Terac?",
    answer:
      "A placement happens when a candidate you submitted is approved on a study. Approval means their submission passed quality review and got paid. You earn commission on every approval that person generates (not just the first one) up to the per-person cap.",
  },
  {
    question: "Can I bring my whole agency onto Terac?",
    answer:
      "Yes. Each recruiter signs up individually and keeps their own commission. There are no team seats to buy and no manager dashboard yet. Every recruiter on your desk operates independently on the platform.",
  },
  {
    question: "How do I submit a candidate?",
    answer:
      "After sign-up, every search in the feed has a one-click share button that produces your unique link. Send it however you already send intros: email, DM, your CRM, LinkedIn. The link handles attribution, and our AI screens the candidate from there.",
  },
  {
    question: "What if my candidate isn't approved?",
    answer:
      "No earnings flow until approval, but there's no penalty either. Source broadly, follow the candidate guidance on each search, and the strongest matches will clear. Quality compounds over time as you learn which searches your network is best suited for.",
  },
  {
    question: "How do taxes / 1099 work?",
    answer:
      "Earnings are treated as independent contractor income. We issue tax forms to US recruiters who earn above the reporting threshold in a calendar year. International recruiters are responsible for filing in their own jurisdiction.",
  },
];
